import { useTranslation } from 'react-i18next';
import { IconButton, Modal } from '@mui/material';
import { XIcon } from '@icons/XIcon';
import type { ProductPlanPrice } from '@repositories/softwareRepository/software.types';
import { numberFormat } from '@utils/numberFormat';
import * as S from './PlanDetailModalStyles';

interface Props {
  open: boolean;
  onClose: () => void;
  data: { prices: ProductPlanPrice[]; currencyUnit: CurrencyUnit };
}

export const PlanDetailModal = ({ onClose, open, data }: Props) => {
  const { t } = useTranslation();

  const formatPrice = (unitPeriod: 'MONTH' | 'YEAR', price: number, currencyUnit: CurrencyUnit) => {
    const periodLabel = unitPeriod === 'MONTH' ? t('Common.month') : t('Plan_Detail_Modal_01');
    const formattedPrice = numberFormat({ num: price, currency: currencyUnit, style: 'currency' });
    return `${periodLabel} ${formattedPrice}`;
  };

  const formatUsage = (usage: number) => {
    return usage === -1 ? '-' : numberFormat({ num: usage });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <S.Container>
        <S.Header>
          {t('Product_Detail_View_01')}
          <IconButton onClick={onClose}>
            <XIcon />
          </IconButton>
        </S.Header>
        <S.Body>
          {data.prices.map(option => {
            return (
              <S.Plan key={option.planOptionId}>
                <div className="plan-name">{option.optionName}</div>
                <S.MetricTable>
                  <thead>
                    <tr>
                      <th>{t('Plan_Detail_Modal_02')}</th>
                      <th>{t('Plan_Detail_Modal_03')}</th>
                      <th>{t('Plan_Detail_Modal_04')}</th>
                      <th>{t('Plan_Detail_Modal_05')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {option.usageMetricPrices.map(price => (
                      <tr key={price.usageMetricPriceId}>
                        <td>{price.usageMetricName}</td>
                        <td>{formatUsage(price.usageFrom)}</td>
                        <td>{formatUsage(price.usageTo)}</td>
                        <td>{formatPrice(price.unitPeriod, price.usageUnitPrice, data.currencyUnit)}</td>
                      </tr>
                    ))}
                  </tbody>
                </S.MetricTable>
              </S.Plan>
            );
          })}
        </S.Body>
      </S.Container>
    </Modal>
  );
};
